import React, { Component } from 'react';

import classNames from 'classnames';
import { Loading } from 'components/cosmos';
import { I18n } from 'components/translate';
import DateHelper from 'helpers/Date';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';

import './FileUploading.scss';

@inject((stores) => ({
  shortLocale: stores.UserStore.shortLocale
}))
@observer
export default class FileUploading extends Component {
  static defaultProps = {
    label: 'files.uploading_file',
    progress: 0,
    remainingTime: null
  };

  static propTypes = {
    hideLabel: PropTypes.bool,
    isBig: PropTypes.bool,
    isShowingLoader: PropTypes.bool,
    isShowingRemainingTime: PropTypes.bool,
    label: PropTypes.string,
    progress: PropTypes.number,
    remainingTime: PropTypes.number,
    shortLocale: PropTypes.string
  };

  get className() {
    return classNames('file--uploading', {
      'file--uploading--big': this.props.isBig
    });
  }

  get progress() {
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    return Math.ceil(this.props.progress * 100);
  }

  get formattedRemainingTime() {
    const { remainingTime, shortLocale } = this.props;

    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    const remainingTimestamp = Date.now() + remainingTime * 1000;
    const locale = DateHelper.locales[shortLocale];

    return DateHelper.distanceInWordsStrict(Date.now(), remainingTimestamp, {
      locale
    });
  }

  render() {
    const { label, isShowingRemainingTime, isShowingLoader, hideLabel } =
      this.props;

    return (
      <div className={this.className}>
        {isShowingLoader && <Loading center />}
        {!hideLabel && (
          <span className="file__progress__label secondary">
            <I18n label={label} />
          </span>
        )}

        <div className="file__progress">
          <div className="file__progress__bar">
            <span
              className="file__progress__current"
              style={{ width: `${this.progress}%` }}
            />
          </div>
          <span className="file__progress__percentage">{`${this.progress}%`}</span>
        </div>
        {isShowingRemainingTime && (
          <div className="file__remaining__time">
            <span className="secondary">
              <I18n
                label="files.estimated_time"
                data={{ time: this.formattedRemainingTime }}
              />
            </span>
          </div>
        )}
      </div>
    );
  }
}
